<template>
    <v-container>
        <v-card>
            <v-card-title>{{text.administrator.traning}}</v-card-title>
            <v-card-text>
                {{text.messege.traing.a}}<br>
                {{text.messege.traing.b}}<br>
                <v-divider></v-divider>
                <div>
                    <v-text-field :label="text.messegeSubject" v-model="traningMode.subject" outlined></v-text-field>
                    <v-textarea :label="text.messegeText" v-model="traningMode.messege" :rules="[traningMode.rule]" outlined :counter="traningMode.limit"></v-textarea>
                    <v-alert v-show="!traningMode.valid" type="error">{{text.messege.invalidRequiredItem}}</v-alert>
                </div>
                <span v-show="traningMode.start">{{text.messege.eventStart}}</span>
            </v-card-text>
            <v-card-actions>
                <div class="d-flex flex-column">
                    <v-switch @change="getTraingKey" v-model="traningMode.lock" :label="text.messege.traing.sw"></v-switch>
                    <v-btn @click="eventGo" :disabled="traningMode.btn">{{text.messege.traing.submit}}</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../lang";
    let text = new lang(0);
    import {apiRequest} from "../lib/api";
    import * as comm from '../common';

    export default Vue.extend({
        data: () => ({
            text : text.Text,
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
            traningMode:{
                lock:true,
                key:"",
                btn:true,
                subject:"",
                messege:"",
                valid:true,
                start:false,
                limit:300,
                rule:(value:string)=> value.length <300 || text.Text.messege.textLengthOver,
            },
        }),
        mounted(){
            this.api = this.$store.state.apiSaver;
        },
        methods:{
            reset(){
                //@ts-ignore
                Object.assign(this.$data,this.$options.data());
            },
            async getTraingKey(){
                if(!this.traningMode.lock){
                    if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                        const response = await this.api.apiRequest.request.admin.getManualEventKey();
                        comm.LoadingOverlay(this,false);
                        if(response.statusCode === 200){
                            this.traningMode.key = response.data.key;
                            this.traningMode.btn = false;
                        }else if(response.statusCode === 401){
                            comm.invalidSession(this);
                        }else{
                            comm.ApiErrorMessege(this,comm.unknowError,true);
                        }
                    }
                }else{
                    this.traningMode.key = "";
                    this.traningMode.btn = true;
                }
            },
            eventGo(){
                if(!this.traningMode.subject || !this.traningMode.messege){
                    this.traningMode.valid = false;
                    return false;
                }
                this.runEvent();
            },
            async runEvent(){
                if(this.api && this.api.connection && this.api.apiRequest){
                    comm.LoadingOverlay(this,true);
                    const response = await this.api.apiRequest.request.admin.reqManualEvent({
                        "key":this.traningMode.key,
                        "type":"manual",
                        "subject":this.traningMode.subject,
                        "messege":this.traningMode.messege,
                    });
                    comm.LoadingOverlay(this,false);
                    if(response.statusCode === 200){
                        this.traningMode.lock = true;
                        this.traningMode.key = "";
                        this.traningMode.btn = true;
                        this.traningMode.start = true;
                    }else if(response.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            },
        },
    });
</script>
